import { createContext, useContext } from 'react'

import type { KinerjaHarianRole } from 'types/kinerja-harian'

type KinerjaHarianRoleContextType = {
  role?: KinerjaHarianRole
}

export const KinerjaHarianRoleContext =
  createContext<KinerjaHarianRoleContextType>({})

export default function useKinerjaHarianRoleContext() {
  return useContext(KinerjaHarianRoleContext)
}
